import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatYouGet } from './components/WhatYouGet';
import { WhatYouImprove } from './components/WhatYouImprove';
import { Bonuses } from './components/Bonuses';
import { UrgencyPricing } from './components/UrgencyPricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { VerifiedPurchasePopup } from './components/VerifiedPurchasePopup';
export function App() {
  useEffect(() => {
    const PIXEL_ID = '1904779843432668';
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-vbred selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <WhatYouGet data-id="element-3" />
      <WhatYouImprove data-id="element-4" />
      <Bonuses data-id="element-5" />
      <UrgencyPricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
      <VerifiedPurchasePopup data-id="element-11" />
    </div>;
}